import { IFormSchemaReport, ICustomerFormSchema, formSchemaReportTypes } from 'src/generated-types/form-schema'
import { isEmptyReportValues, schemaHasRequiredFields } from './checklist-utils'

export interface IChecklistEntryState {
  versionId: number
  values: Record<string, any>
  isValid: boolean
}

export type ChecklistsState = Record<number, IChecklistEntryState>

export const hasFilledChecklistValues = (state: ChecklistsState): boolean =>
  Object.values(state).some(s => !isEmptyReportValues(s.values))

export const isChecklistGroupValid = (schemas: ICustomerFormSchema[], state: ChecklistsState): boolean =>
  schemas.every(schema => {
    const entry = state[schema.id as number]
    return entry ? entry.isValid : !schemaHasRequiredFields(schema)
  })

export const buildChecklistsStateFromReports = (
  reports: IFormSchemaReport[],
  schemas: ICustomerFormSchema[],
): ChecklistsState => {
  const state: ChecklistsState = {}
  reports.forEach(report => {
    try {
      const values = typeof report.values === 'string' ? JSON.parse(report.values) : report.values
      const matchingSchema = schemas.find(s => s.version?.id === report.formSchemaVersionId)
      if (matchingSchema) {
        state[matchingSchema.id as number] = {
          versionId: report.formSchemaVersionId as number,
          values,
          isValid: true,
        }
      }
    } catch (e) {
      void e
    }
  })
  return state
}

export const buildReportsFromChecklistsState = (state: ChecklistsState): IFormSchemaReport[] =>
  Object.values(state)
    .filter(s => !isEmptyReportValues(s.values))
    .map(
      s =>
        ({
          formSchemaVersionId: s.versionId,
          values: JSON.stringify(s.values),
          type: formSchemaReportTypes.MainComponent,
        } as IFormSchemaReport),
    )

export const isSaveDisabled = (
  currentSelectionCount: number,
  isGroupValid: boolean,
  hasFilledValues: boolean,
  editingGroupId: string | null,
): boolean => currentSelectionCount === 0 || !isGroupValid || (!hasFilledValues && !editingGroupId)
